import React, { useEffect, useState } from 'react';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, Truck, QrCode, Search, Clock, CheckCircle2, Play, Pause, Camera, AlertCircle, Package, ChevronRight, MoreVertical, History } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
type ReceivingStatus = 'Arrival Queue' | 'Check-in' | 'Receiving' | 'Completion';
export function CheckInReceiving() {
  const [view, setView] = useState<ReceivingStatus>('Arrival Queue');
  const [timer, setTimer] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    let interval: any;
    if (isTimerRunning) {
      interval = setInterval(() => {
        setTimer(prev => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isTimerRunning]);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-450">
      <header className="bg-white px-4 py-6 border-b border-slate-200 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-451">
        <div className="flex items-center gap-4" data-id="element-452">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-453">
            <ArrowLeft size={24} data-id="element-454" />
          </button>
          <BilingualText en={view} ar={view === 'Arrival Queue' ? 'قائمة الوصول' : 'الاستلام'} className="text-xl font-bold" data-id="element-455" />
        </div>
        {view === 'Receiving' && <div className="flex items-center gap-3 bg-orange-50 px-4 py-2 rounded-full border border-orange-100" data-id="element-456">
            <Clock size={16} className="text-orange-600 animate-pulse" data-id="element-457" />
            <span className="font-mono font-bold text-orange-700" data-id="element-458">
              {formatTime(timer)}
            </span>
          </div>}
      </header>

      <main className="p-4 md:p-8 max-w-5xl mx-auto" data-id="element-459">
        {view === 'Arrival Queue' && <div className="space-y-6 animate-in fade-in duration-500" data-id="element-460">
            {/* KPI Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-461">
              <ArrivalKpi label="Expected" value="12" color="text-slate-600" data-id="element-462" />
              <ArrivalKpi label="Arrived" value="5" color="text-blue-600" data-id="element-463" />
              <ArrivalKpi label="Receiving" value="3" color="text-orange-600" data-id="element-464" />
              <ArrivalKpi label="Late" value="2" color="text-red-600" data-id="element-465" />
            </div>

            <div className="flex flex-col md:flex-row gap-4" data-id="element-466">
              <div className="flex-1 relative" data-id="element-467">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-468" />
                <input type="text" placeholder="Scan QR or Search Plate..." className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-xl shadow-sm" data-id="element-469" />
              </div>
              <button onClick={() => setView('Check-in')} className="btn-primary" data-id="element-470">
                <QrCode size={18} data-id="element-471" />
                <span data-id="element-472">Scan QR Code</span>
              </button>
            </div>

            <div className="space-y-3" data-id="element-473">
              <ArrivalCard plate="LKR 4920" supplier="Global Logistics" time="09:30 AM" status="Arrived" onCheckIn={() => setView('Check-in')} data-id="element-474" />
              <ArrivalCard plate="KSA 1122" supplier="FastTrack Trading" time="10:15 AM" status="Expected" data-id="element-475" />
              <ArrivalCard plate="DXB 8833" supplier="Prime Goods Ltd" time="08:00 AM" status="Late" delay="45 min" data-id="element-476" />
            </div>
          </div>}

        {view === 'Check-in' && <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500" data-id="element-477">
            <div className="card p-8 text-center space-y-6" data-id="element-478">
              <div className="w-20 h-20 bg-blue-50 text-[#2E3192] rounded-full flex items-center justify-center mx-auto" data-id="element-479">
                <Truck size={40} data-id="element-480" />
              </div>
              <div className="space-y-1" data-id="element-481">
                <h2 className="text-2xl font-bold text-slate-800" data-id="element-482">
                  Verify Appointment
                </h2>
                <p className="text-slate-500" data-id="element-483">
                  Truck Plate:{' '}
                  <span className="font-bold text-slate-700" data-id="element-484">LKR 4920</span>
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 text-left p-4 bg-slate-50 rounded-2xl" data-id="element-485">
                <InfoBox label="Shipment" value="ASN-98231" data-id="element-486" />
                <InfoBox label="Supplier" value="Global Logistics" data-id="element-487" />
                <InfoBox label="Appt. Time" value="09:30 AM" data-id="element-488" />
                <InfoBox label="Quantity" value="42 Cartons" data-id="element-489" />
              </div>

              <div className="flex gap-3 pt-4" data-id="element-490">
                <button onClick={() => setView('Arrival Queue')} className="btn-secondary flex-1 py-4" data-id="element-491">
                  Back
                </button>
                <button onClick={() => setView('Receiving')} className="btn-primary flex-[2] py-4" data-id="element-492">
                  Confirm Check-in
                </button>
              </div>
            </div>
          </div>}

        {view === 'Receiving' && <div className="space-y-6 animate-in fade-in duration-500" data-id="element-493">
            <div className="card p-6 space-y-6" data-id="element-494">
              <div className="flex justify-between items-start" data-id="element-495">
                <BilingualText en="Receiving Process" ar="عملية الاستلام" className="text-xl" data-id="element-496" />
                <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-bold uppercase" data-id="element-497">
                  In Progress
                </span>
              </div>

              <div className="space-y-4" data-id="element-498">
                <div className="flex justify-between items-center p-4 bg-slate-50 rounded-xl" data-id="element-499">
                  <div className="flex items-center gap-3" data-id="element-500">
                    <Package className="text-slate-400" size={20} data-id="element-501" />
                    <span className="font-medium" data-id="element-502">Expected Quantity</span>
                  </div>
                  <span className="text-xl font-bold" data-id="element-503">42</span>
                </div>

                <div className="space-y-2" data-id="element-504">
                  <label className="text-xs font-bold text-slate-400 uppercase" data-id="element-505">
                    Received Quantity
                  </label>
                  <input type="number" defaultValue={42} className="w-full p-4 bg-white border-2 border-slate-200 rounded-xl text-2xl font-bold focus:border-[#2E3192] outline-none transition-all" data-id="element-506" />
                </div>

                <div className="space-y-2" data-id="element-507">
                  <label className="text-xs font-bold text-slate-400 uppercase" data-id="element-508">
                    Notes / Damages
                  </label>
                  <textarea placeholder="Enter any receiving notes or damage details..." className="w-full p-4 bg-white border-2 border-slate-200 rounded-xl min-h-[100px] outline-none focus:border-[#2E3192]" data-id="element-509" />
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-510">
                  <button className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-slate-200 rounded-xl text-slate-400 hover:bg-slate-50 transition-all" data-id="element-511">
                    <Camera size={24} className="mb-2" data-id="element-512" />
                    <span className="text-xs font-bold" data-id="element-513">Add Photo</span>
                  </button>
                  <div className="p-6 bg-slate-50 rounded-xl flex items-center justify-center text-slate-300 italic text-sm" data-id="element-514">
                    No photos added
                  </div>
                </div>
              </div>

              <div className="flex gap-3 pt-4" data-id="element-515">
                <button onClick={() => setIsTimerRunning(!isTimerRunning)} className={`flex-1 py-4 rounded-xl font-bold flex items-center justify-center gap-2 transition-all ${isTimerRunning ? 'bg-yellow-50 text-yellow-700 border border-yellow-200' : 'bg-blue-50 text-[#2E3192] border border-blue-200'}`} data-id="element-516">
                  {isTimerRunning ? <Pause size={20} data-id="element-517" /> : <Play size={20} data-id="element-518" />}
                  {isTimerRunning ? 'Pause' : 'Resume'}
                </button>
                <button onClick={() => setView('Completion')} className="btn-primary flex-[2] py-4" data-id="element-519">
                  Complete Receiving
                </button>
              </div>
            </div>
          </div>}

        {view === 'Completion' && <div className="space-y-6 animate-in zoom-in-95 duration-500" data-id="element-520">
            <div className="card p-8 text-center space-y-6" data-id="element-521">
              <div className="w-24 h-24 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto" data-id="element-522">
                <CheckCircle2 size={48} data-id="element-523" />
              </div>
              <div className="space-y-2" data-id="element-524">
                <h2 className="text-2xl font-bold text-slate-800" data-id="element-525">
                  Receiving Completed!
                </h2>
                <p className="text-slate-500" data-id="element-526">
                  Shipment #ASN-98231 has been successfully received.
                </p>
              </div>

              <div className="divide-y divide-slate-100 bg-slate-50 rounded-2xl overflow-hidden" data-id="element-527">
                <SummaryRow label="Expected" value="42" data-id="element-528" />
                <SummaryRow label="Received" value="42" data-id="element-529" />
                <SummaryRow label="Difference" value="0" color="text-green-600" data-id="element-530" />
                <SummaryRow label="Duration" value={formatTime(timer)} data-id="element-531" />
              </div>

              <div className="flex flex-col gap-3 pt-4" data-id="element-532">
                <button className="btn-primary py-4" data-id="element-533">
                  Print Receiving Summary
                </button>
                <button onClick={() => {
              setView('Arrival Queue');
              setTimer(0);
              setIsTimerRunning(false);
            }} className="btn-secondary py-4" data-id="element-534">
                  Back to Queue
                </button>
              </div>
            </div>
          </div>}
      </main>
    </div>;
}
function ArrivalKpi({
  label,
  value,
  color
}: any) {
  return <div className="card p-4 text-center" data-id="element-535">
      <div className={`text-2xl font-black ${color}`} data-id="element-536">{value}</div>
      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider" data-id="element-537">
        {label}
      </div>
    </div>;
}
function ArrivalCard({
  plate,
  supplier,
  time,
  status,
  delay,
  onCheckIn
}: any) {
  const colors: any = {
    Expected: 'bg-slate-100 text-slate-600',
    Arrived: 'bg-blue-100 text-blue-700',
    Late: 'bg-red-100 text-red-700'
  };
  return <div className="card p-4 flex items-center justify-between hover:border-[#2E3192] transition-all group" data-id="element-538">
      <div className="flex items-center gap-4" data-id="element-539">
        <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center text-[#2E3192] font-bold" data-id="element-540">
          {plate.split(' ')[0]}
        </div>
        <div data-id="element-541">
          <div className="font-bold text-slate-800" data-id="element-542">{plate}</div>
          <div className="text-xs text-slate-500" data-id="element-543">{supplier}</div>
        </div>
      </div>
      <div className="flex items-center gap-4" data-id="element-544">
        <div className="text-right" data-id="element-545">
          <div className="text-sm font-bold text-slate-700" data-id="element-546">{time}</div>
          <div className={`text-[10px] font-bold px-2 py-0.5 rounded uppercase mt-1 ${colors[status]}`} data-id="element-547">
            {status} {delay && `(${delay})`}
          </div>
        </div>
        {status === 'Arrived' || status === 'Late' ? <button onClick={onCheckIn} className="p-2 bg-blue-50 text-[#2E3192] rounded-lg hover:bg-blue-100 transition-colors" data-id="element-548">
            <ChevronRight size={20} data-id="element-549" />
          </button> : <button className="p-2 text-slate-300" data-id="element-550">
            <MoreVertical size={20} data-id="element-551" />
          </button>}
      </div>
    </div>;
}
function InfoBox({
  label,
  value
}: any) {
  return <div data-id="element-552">
      <div className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-553">
        {label}
      </div>
      <div className="text-sm font-bold text-slate-700" data-id="element-554">{value}</div>
    </div>;
}
function SummaryRow({
  label,
  value,
  color = 'text-slate-700'
}: any) {
  return <div className="flex justify-between items-center px-6 py-3" data-id="element-555">
      <span className="text-sm text-slate-500 font-medium" data-id="element-556">{label}</span>
      <span className={`font-bold ${color}`} data-id="element-557">{value}</span>
    </div>;
}